import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, ChevronDown } from "lucide-react";
import { LogoFull } from "@/components/Logo";
import { businessLines } from "@/data/businessLines";

const links = [
  { to: "/chi-siamo", label: "Chi Siamo" },
  { to: "/casi-studio", label: "Casi Studio" },
  { to: "/investitori", label: "Per gli Investitori" },
  { to: "/contatti", label: "Contatti" },
];

export function Navbar() {
  const [open, setOpen] = useState(false);
  const [linesOpen, setLinesOpen] = useState(false);

  const linkCls = ({ isActive }) =>
    `text-sm tracking-wide transition-colors ${
      isActive ? "text-[#C5A059]" : "text-gray-300 hover:text-white"
    }`;

  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 inset-x-0 z-50 bg-[#0D1B2A]/85 backdrop-blur-xl border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-[72px] flex items-center justify-between">
        <Link to="/" data-testid="nav-home-logo" onClick={() => setOpen(false)}>
          <LogoFull compact />
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          <NavLink to="/chi-siamo" className={linkCls} data-testid="nav-chi-siamo">
            Chi Siamo
          </NavLink>

          <div
            className="relative"
            onMouseEnter={() => setLinesOpen(true)}
            onMouseLeave={() => setLinesOpen(false)}
          >
            <button
              data-testid="nav-lines-trigger"
              className="text-sm tracking-wide text-gray-300 hover:text-white flex items-center gap-1"
            >
              Metodo &amp; Servizi <ChevronDown size={14} />
            </button>
            {linesOpen && (
              <div className="absolute left-1/2 -translate-x-1/2 top-full pt-4">
                <div className="w-[520px] bg-[#0D1B2A] border border-[#C5A059]/20 shadow-2xl grid grid-cols-2 gap-px">
                  {businessLines.map((b) => (
                    <Link
                      key={b.slug}
                      to={`/linee/${b.slug}`}
                      data-testid={`nav-line-${b.slug}`}
                      className="px-5 py-3 text-sm text-gray-300 hover:text-[#C5A059] hover:bg-white/5 transition-colors border border-white/5"
                    >
                      {b.name}
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>

          <NavLink to="/casi-studio" className={linkCls} data-testid="nav-casi-studio">
            Casi Studio
          </NavLink>
          <NavLink to="/investitori" className={linkCls} data-testid="nav-investitori">
            Per gli Investitori
          </NavLink>
          <NavLink to="/contatti" className={linkCls} data-testid="nav-contatti">
            Contatti
          </NavLink>

          <Link
            to="/contatti"
            data-testid="nav-cta"
            className="bg-[#C5A059] text-[#0D1B2A] hover:bg-[#D8B978] transition-colors text-sm font-medium px-5 py-2.5"
          >
            Richiedi Valutazione Strategica
          </Link>
        </nav>

        <button
          className="lg:hidden text-white"
          onClick={() => setOpen((o) => !o)}
          data-testid="nav-mobile-toggle"
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0D1B2A] border-t border-white/10 max-h-[80vh] overflow-y-auto">
          <div className="px-5 py-4 space-y-1">
            <NavLink
              to="/chi-siamo"
              onClick={() => setOpen(false)}
              data-testid="mnav-chi-siamo"
              className="block py-2.5 text-base text-gray-200"
            >
              Chi Siamo
            </NavLink>

            <div className="label-eyebrow py-2">Metodo &amp; Servizi</div>
            {businessLines.map((b) => (
              <Link
                key={b.slug}
                to={`/linee/${b.slug}`}
                onClick={() => setOpen(false)}
                data-testid={`mnav-line-${b.slug}`}
                className="block py-2 text-sm text-gray-300"
              >
                {b.name}
              </Link>
            ))}
            <div className="h-px bg-white/10 my-3" />
            {links
              .filter((l) => l.to !== "/chi-siamo")
              .map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  onClick={() => setOpen(false)}
                  data-testid={`mnav-${l.to.slice(1)}`}
                  className="block py-2.5 text-base text-gray-200"
                >
                  {l.label}
                </NavLink>
              ))}
            <Link
              to="/contatti"
              onClick={() => setOpen(false)}
              className="mt-3 block text-center bg-[#C5A059] text-[#0D1B2A] font-medium py-3"
            >
              Richiedi Valutazione Strategica
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
